import { useEffect, useState } from 'react'

/**
 * Trails `value` by `delay`, so typing in a search box does not fire a request
 * per keystroke. The immediate value still drives the input; only the query key
 * waits.
 */
export function useDebounced<T>(value: T, delay = 300): T {
  const [settled, setSettled] = useState(value)

  useEffect(() => {
    const timer = setTimeout(() => setSettled(value), delay)
    return () => clearTimeout(timer)
  }, [value, delay])

  return settled
}
